import { find, cloneDeep } from 'lodash';

import * as dashboardApi from '../api';
import { ActionTypes, getActionCardData } from '../components/cards/ActionCard';
import { comparator, ComparatorTypes } from '../utils/comparator';
import { fetchComponentConfig } from './component-config-actions';
import { showErrorPopup } from './notification-actions';

const shouldDisplayAction = (actionId, actionCards) => {
    const checkId = parseInt(actionId);
    const action = find(actionCards, { memberActionCardSettingTypeId: checkId });
    if (action) {
        return action.isEnabled;
    }
    return true;
};

const getStartedList = (auth, dashboard) => {
    if (auth && auth.user && dashboard) {
        const actionCards = (dashboard && dashboard.memberActionCards) || [];
        const list = [];
        const isFromOrganizerFlow = auth.user.segments && (auth.user.segments.indexOf('Club_Organizer') > -1);
        const proCLubOrganizer = auth.user.isProClubOrganizer || auth.user.isProClubHeadOrganizer;
        if (isFromOrganizerFlow && !proCLubOrganizer) {
            if (shouldDisplayAction(ActionTypes.CREATE_PRO_CLUB, actionCards)) {
                const createProCLub = getActionCardData({ type: ActionTypes.CREATE_PRO_CLUB });
                list.push({ id: `action-${createProCLub.id}`, type: 'action', item: createProCLub });
            }
        } else if (proCLubOrganizer) {
            const userClubs = dashboard.clubs && dashboard.clubs.filter((club) => { return (club.clubMemberRole.id === 1 || club.clubMemberRole.id === 2); });
            const clubId = userClubs && userClubs.length > 0 ? userClubs[0].id : null;
            // Club Organizer actions
            if (shouldDisplayAction(ActionTypes.CREATE_FIRST_EVENT, actionCards) && userClubs && userClubs.length > 0) {
                const createFirstEvent = getActionCardData({ type: ActionTypes.CREATE_FIRST_EVENT });
                list.push({ id: `action-${createFirstEvent.id}`, type: 'action', item: createFirstEvent });
            }

            if (shouldDisplayAction(ActionTypes.COMPLETE_CLUB_PROFILE, actionCards) && clubId) {
                const completeClubProfile = getActionCardData({ type: ActionTypes.COMPLETE_CLUB_PROFILE, clubId });
                list.push({ id: `action-${completeClubProfile.id}`, type: 'action', item: completeClubProfile });
            }
        } else {
            // Player actions
            if (shouldDisplayAction(ActionTypes.POST_SCORE, actionCards)) {
                const postScoreAction = getActionCardData({ type: ActionTypes.POST_SCORE });
                list.push({ id: `action-${postScoreAction.id}`, type: 'action', item: postScoreAction });
            }
            if (shouldDisplayAction(ActionTypes.START_PERSONAL_CLUB, actionCards)) {
                const startPersonalClubAction = getActionCardData({ type: ActionTypes.START_PERSONAL_CLUB });
                list.push({ id: `action-${startPersonalClubAction.id}`, type: 'action', item: startPersonalClubAction });
            }
            if (shouldDisplayAction(ActionTypes.FIND_EVENT, actionCards)) {
                const findEventsAction = getActionCardData({ type: ActionTypes.FIND_EVENT });
                list.push({ id: `action-${findEventsAction.id}`, type: 'action', item: findEventsAction });
            }
            if (shouldDisplayAction(ActionTypes.COMPLETE_PROFILE, actionCards)) {
                const playerId = auth.user.claimedPlayer && auth.user.claimedPlayer.playerId;
                const completeProfile = getActionCardData({ type: ActionTypes.COMPLETE_PROFILE, playerId });
                list.push({ id: `action-${completeProfile.id}`, type: 'action', item: completeProfile });
            }
        }
        return list;
    }
    return null;
};

export function getMemberDashboard() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD' });
        dispatch(fetchComponentConfig('dashboard'));
        try {
            const dashBoardResult = await dashboardApi.getMemberDashBoard(mainApi);
            const { data } = dashBoardResult;
            if (data.error) {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_FAILURE', data });
            } else {
                dispatch({
                    type: 'DASHBOARD:FETCH_DASHBOARD_SUCCESS',
                    data: {
                        profile: data.profile,
                        member: data.member,
                        memberActionCards: data.memberActionCards,
                    },
                });
            }
        } catch (error) {
            console.log(error);
            dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_FAILURE' });
        }

        // dispatch(getMemberDashboardClubs());
        dispatch(updateGettingStarted());
        dispatch(getMemberDashboardNew());
        dispatch(getMemberDashboardNotification());
        dispatch(getMemberDashboardResults());
        dispatch(getMemberPendingResults());
        dispatch(getFlexLeagueMatchCards());
    };
}

export function getMemberDashboardNew() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NEW' });
        try {
            const newDashboardItems = await dashboardApi.getMemberDashBoardNew(mainApi);
            const { data } = newDashboardItems;
            if (data && data.error) {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NEW_FAILURE', data });
            } else {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NEW_SUCCESS', data });
            }
        } catch (error) {
            console.log(error);
            dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NEW_FAILURE' });
        }
    };
}

export function getMemberDashboardNotification() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NOTIFICATION' });
        try {
            const newDashboardNotification = await dashboardApi.getMemberDashBoardNotification(mainApi);
            const { data } = newDashboardNotification;
            if (data && data.error) {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NOTIFICATION_FAILURE', data });
            } else {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NOTIFICATION_SUCCESS', data });
            }
        } catch (error) {
            console.log(error);
            dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_NOTIFICATION_FAILURE' });
        }
    };
}

export function getMemberDashboardResults() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_RESULTS' });
        try {
            const newDashboardResults = await dashboardApi.getMemberDashBoardResults(mainApi);
            const { data } = newDashboardResults;
            if (data && data.error) {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_RESULTS_FAILURE', data });
            } else {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_RESULTS_SUCCESS', data });
            }
        } catch (error) {
            console.log('GET RESULTS ERROR: ', error);
            dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_RESULTS_FAILURE' });
        }
    };
}

export function getMemberPendingResults() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'DASHBOARD:FETCH_PENDING_RESULTS' });
        try {
            const newDashboardResults = await dashboardApi.getMemberPendingResults(mainApi);
            const { data } = newDashboardResults;
            if (data && data.error) {
                dispatch({ type: 'DASHBOARD:FETCH_PENDING_RESULTS_FAILURE', data });
            } else {
                dispatch({ type: 'DASHBOARD:FETCH_PENDING_RESULTS_SUCCESS', data });
            }
        } catch (error) {
            console.log('GET PENDING RESULTS ERROR: ', error);
            dispatch({ type: 'DASHBOARD:FETCH_PENDING_RESULTS_FAILURE' });
        }
    };
}

export function getFlexLeagueMatchCards() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'DASHBOARD:FETCH_FLEX_LEAGUE_MATCH_CARD' });
        try {
            const newDashboardMatchCards = await dashboardApi.getFlexLeagueMatchCards(mainApi);
            const { data } = newDashboardMatchCards;
            if (data && data.error) {
                dispatch({ type: 'DASHBOARD:FETCH_FLEX_LEAGUE_MATCH_CARD_FAILURE' });
            } else {
                dispatch({ type: 'DASHBOARD:FETCH_FLEX_LEAGUE_MATCH_CARD_SUCCESS', data });
            }
        } catch (error) {
            console.log('GET FLEX LEAGUE MATCH CARDS ERROR: ', error);
            dispatch({ type: 'DASHBOARD:FETCH_FLEX_LEAGUE_MATCH_CARD_FAILURE' });
        }
    };
}

export function getMemberDashboardClubs() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_CLUBS' });
        try {
            const dashboardClubsResult = await dashboardApi.getMemberDashBoardClubs(mainApi);
            const { data } = dashboardClubsResult;
            if (data.error) {
                dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_CLUBS_FAILURE', data });
            } else {
                const clubsAndSchools = [];

                if (data.clubs) {
                    data.clubs.forEach((club) => {
                        const object = {};
                        object.id = `club-${club.id}`;
                        object.type = 'club';
                        object.item = club;
                        object.sortName = club.name;
                        clubsAndSchools.push(object);
                    });
                }
                if (data.schools) {
                    data.schools.forEach((school) => {
                        const object = {};
                        object.id = `${school.type}-${school.id}`;
                        object.type = school.type;
                        object.item = school;
                        object.sortName = school.name;
                        clubsAndSchools.push(object);
                    });
                }
                clubsAndSchools.sort(comparator([{ type: ComparatorTypes.STRING, field: 'sortName' }]));

                dispatch({
                    type: 'DASHBOARD:FETCH_DASHBOARD_CLUBS_SUCCESS',
                    data: {
                        clubs: data.clubs,
                        schools: data.schools,
                        clubsAndSchools,
                    },
                });
                dispatch(updateGettingStarted());
            }
        } catch (error) {
            console.log(error);
            dispatch({ type: 'DASHBOARD:FETCH_DASHBOARD_CLUBS_FAILURE' });
        }
    };
}

export function disableMemberActionCard(cardId) {
    return async (dispatch, getState) => {
        const { auth, dashboard } = getState();
        try {
            const newDashBoard = cloneDeep(dashboard);
            const action = find(newDashBoard.memberActionCards, { memberActionCardSettingTypeId: parseInt(cardId) });
            if (action) {
                action.isEnabled = false;
            } else {
                newDashBoard.memberActionCards.push({
                    isEnabled: false,
                    memberActionCardSettingTypeId: parseInt(cardId),
                    memberId: auth.user.id,
                });
            }
            dispatch({
                type: 'DASHBOARD:UPDATE_DASHBOARD',
                data: {
                    gettingStartedList: getStartedList(auth, newDashBoard),
                    memberActionCards: newDashBoard.memberActionCards,
                },
            });
            dispatch(updateGettingStarted());
        } catch (error) {
            dispatch(showErrorPopup({
                message: 'Dashboard update failed',
                error,
            }));
        }
    };
}

export function updateGettingStarted() {
    return async (dispatch, getState) => {
        const { auth, dashboard } = getState();
        dispatch({
            type: 'DASHBOARD:UPDATE_GETTING_STARTED_LIST',
            data: {
                gettingStartedList: getStartedList(auth, dashboard),
            },
        });
    };
}
